var path = 'src/app/components/administration/holiday/holiday-branches.template.html';
var html = "  <section class=\"horizontal-padding\">\n  <branches-list detail-link=\"#!/admin/organization/holidays\"></branches-list>\n</section>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;